export default function useBack(fallbackRoute?: string) {
  const router = useRouter()

  const getBackRoute = () => {
    return router.options.history.state.back
  }

  const goBack = () => {
    const backRoute = getBackRoute()
    if (backRoute) {
      router.back()
    }
    else if (fallbackRoute) {
      router.push(fallbackRoute)
    }
  }
  return { goBack, getBackRoute }
}
